import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
import util, { ridUrlParam } from "@src/utils/util.js"
import shareIcon from "../images/shareIcon.webp"
import shareIcon_dark from "../images/shareIcon_dark.webp"

export default {
  data() {
    return {
      shareIcon,
      shareIcon_dark,
      isShowNotAvailable: false,
      isNight: false,
      inviteTypeSingin: false,
      inviteName: "",
      inviteCode: "",
      rewardType: 0,
      rewardInvitedNum: 0,
      symbol: "",
      outPic: "",
      strs1: '',
      urlJson: {},
      isShowSuccessToast: false,
      isShowToast: false
    };
  },
  computed: {
    shareIconUrl() {
      if (this.isNight) {
        return shareIcon_dark
      } else {
        return shareIcon
      }
    },
  },
  mounted() {
    // this.isNight = typeof window.OppoWebPage
    let loading = document.getElementById('index-loading')
    loading.style.display = 'none'
    this.$route.fullPath.split("&").map((item) => {
      let arr = item.split("=")
      this.urlJson[arr[0]] = arr[1]
    })
    let { inviteCode, inviteName, rewardType, rewardInvitedNum, symbol, outPic } = this.urlJson
    this.rewardType = rewardType
    this.inviteCode = inviteCode
    this.inviteName = inviteName.replace(/-/g, " ")
    this.rewardInvitedNum = rewardInvitedNum
    this.symbol = decodeURIComponent(symbol)
    this.outPic = decodeURIComponent(outPic)
    if (this.rewardType == 2) {
      this.inviteTypeSingin = true
    }
  },
  methods: {
    openApp() {
      //打开应用
      let { oapsUrl, webUrl } = this.$route.query
      if (oapsUrl) {
        let deepLink = decodeURIComponent(oapsUrl)
        if (webUrl) {
          deepLink += '?weburl=' + encodeURIComponent(webUrl)
        }
        location.href = deepLink
      } else {
        const statsArr = ['score', 'inviteCode', 'inviteName', 'rewardType', 'rewardInvitedNum', 'symbol', 'outPic']
        let url = location.href.replace(/(s|S)hare(P|p)age/g, 'home')//获取当前页面的url，去掉了sharePage
        location.href = `oaps://qg/web?weburl=${encodeURIComponent(ridUrlParam(url, statsArr))}`//跳转到apk中的活动页面
      }
      let that = this
      this.isShowToast = true
      setTimeout(() => {
        that.isShowToast = false
      }, 1500)
    },
    copy() {
      var text = document.getElementById("text").innerText;
      var input = document.getElementById("copycode");
      input.value = text; // 修改文本框的内容
      input.setAttribute("readonly", "readonly")
      input.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.isShowSuccessToast = true
      let that = this
      setTimeout(function () {
        that.isShowSuccessToast = false
      }, 3000);
    },
    openGoogle() {
      location.href = 'https://play.google.com/store/apps/details?id=com.heytap.quickgame'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/sharePage/scripts/index.js